module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-04.6b396a75.jpg";